import { Reducer, useReducer } from 'react'

import {
  CustomerCategory,
  CustomersListFilterInput,
  CustomersListSortInput,
  SortDirection
} from '@app/graphql/types'
import { CustomersQuery, useCustomersQuery } from '@app/queries/Customers/Customers.queries'

export type CustomerItem = CustomersQuery['customers']['items'][number]

type State = {
  filters: CustomersListFilterInput
  sorts: CustomersListSortInput
  pagination: {
    take: number
    skip: number
  }
}

type Action =
  | {
      type: 'SET_FILTER'
      payload: CustomersListFilterInput
    }
  | {
      type: 'SET_PAGINATION'
      payload: {
        take: number
        skip: number
      }
    }
  | {
      type: 'SET_SORT'
      payload: CustomersListSortInput
    }
  | {
      type: 'RESET'
    }

const DEFAULT_PAGINATION = {
  take: 50,
  skip: 0
}
const DEFAULT_SORT = { memberSince: SortDirection.Desc }
const DEFAULT_FILTER = {
  customerCategory: { equals: CustomerCategory.Active },
  keyword: undefined
}

const reducer: Reducer<State, Action> = (state, action) => {
  switch (action.type) {
    case 'SET_FILTER': {
      return {
        pagination: DEFAULT_PAGINATION,
        sorts: DEFAULT_SORT,
        filters: { ...state.filters, ...action.payload }
      }
    }

    case 'SET_PAGINATION': {
      return {
        ...state,
        pagination: action.payload
      }
    }

    case 'SET_SORT': {
      return {
        ...state,
        sorts: action.payload
      }
    }

    case 'RESET': {
      return {
        sorts: DEFAULT_SORT,
        pagination: DEFAULT_PAGINATION,
        filters: {
          ...DEFAULT_FILTER,
          keyword: state.filters.keyword
        }
      }
    }
  }
}

export const useCustomerListTable = () => {
  const [query, dispatch] = useReducer(reducer, {
    sorts: DEFAULT_SORT,
    pagination: DEFAULT_PAGINATION,
    filters: {
      ...DEFAULT_FILTER
    }
  })

  const { data, loading, error } = useCustomersQuery({
    variables: query,
    fetchPolicy: 'network-only',
    onCompleted: () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  })

  return {
    data,
    loading,
    error,
    query,
    dispatch
  }
}
